export type Page = 'home' | 'vegan'

export type IngredientSection = {
  title: string
  items: string[]
  src: string
  hiddenOn?: Page[]
}

export type IngredientCardData = {
  id: number
  title: string
  sections: IngredientSection[]
}

export const ingredientCards: IngredientCardData[] = [
  {
    id: 1,
    title:
      '20g High Quality<br class="hidden xlr:block 3xl:hidden"> Protein 💪',
    sections: [
      {
        title: 'Whey Protein',
        items: [
          'Fast Digesting',
          'Low Sodium',
          'Supports Muscle<br class="hidden lg:block"> Growth & Recovery'
        ],
        src: 'https://cdn.shopify.com/s/files/1/1209/5722/files/protein-1.png?v=1753886475',
        hiddenOn: [ 'vegan' ]
      },
      {
        title: 'Pea Protein',
        items: [ 'Vegan', 'Lactose Free', 'Cholesterol Free' ],
        src: 'https://cdn.shopify.com/s/files/1/1209/5722/files/protein-2.png?v=1753886474'
      }
    ]
  },
  {
    id: 2,
    title: 'Whole Grain<br class="hidden xlr:block 3xl:hidden"> Oats 🥣',
    sections: [
      {
        title: 'Gluten-Free Rolled Oats',
        items: [ 'Curbs Hunger', 'High Fiber', 'Supports Digestion' ],
        src: 'https://cdn.shopify.com/s/files/1/1209/5722/files/whole.png?v=1753886474'
      }
    ]
  },
  {
    id: 3,
    title: 'Functional<br class="hidden xlr:block 3xl:hidden"> Nutrition 🌱',
    sections: [
      {
        title: 'Chia Seed',
        items: [ 'High Fiber', 'Rich in Omega 3s', 'Antioxidants' ],
        src: 'https://cdn.shopify.com/s/files/1/1209/5722/files/superfoods-1.png?v=1753886474'
      },
      {
        title: 'Flax Seed',
        items: [
          'High Fiber',
          'Helps Digestion',
          'Keeps You Full for<br class="hidden lg:block"> Longer'
        ],
        src: 'https://cdn.shopify.com/s/files/1/1209/5722/files/superfoods-2.png?v=1753886474'
      }
    ]
  },
  {
    id: 4,
    title: 'Real Food<br class="hidden xlr:block 3xl:hidden"> Ingredients 🍓',
    sections: [
      {
        title:
          '<span class="hidden lg:inline-block">Real Food Ingredients </span> For<br class="hidden lg:block"> Unmatched Taste & Texture',
        items: [ 'Real Fruit', 'Real Cocoa', 'Real Spices' ],
        src: 'https://cdn.shopify.com/s/files/1/1209/5722/files/real-ingredients.png?v=1753886474'
      }
    ]
  }
]

export const visibleSections = (sections: IngredientSection[], page?: Page) => {
  return sections.filter(
    (section) => !section.hiddenOn?.includes(page as Page)
  )
}
